import { useMemo } from 'react';

import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import dayjs from 'dayjs';

import { message } from '../message';

export function useRemainingDaysText(departureDate?: string | Date): string {
	const microCopies = useMicroCopyContext();

	return useMemo(() => {
		const remainingDays = dayjs(departureDate).diff(dayjs(), 'days');

		if (remainingDays < 0) return microCopies['user.booking.upcoming.onGoing'];

		if (remainingDays === 0) return microCopies['user.booking.upcoming.today'];

		return message(microCopies['user.booking.upcoming.remainingDays'], {
			count: remainingDays,
		});
	}, [microCopies, departureDate]);
}
